import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-store-connections',
  templateUrl: './store-connections.component.html',
  styleUrls: ['./store-connections.component.css'],
})
export class StoreConnectionsComponent implements OnInit {

  storeConnectionList: any;
  searchText: any;

  constructor(private router: Router) {
    this.storeConnectionList =
      [{
        imageUrl: "assets/images/MAGENTO.png",
        carrierName: 'Magento',
        disable: true
      },
      {
        imageUrl: "assets/images/SHOPIFY.png",
        carrierName: 'Shopify',
        disable: true
      },
      {
        imageUrl: "assets/images/AMAZON.png",
        carrierName: 'Amazon',
        disable: true
      },
      {
        imageUrl: "assets/images/SHOPCLUES.png",
        carrierName: 'Shopclues',
        disable: true
      },
      {
        imageUrl: "assets/images/FLIPKART.png",
        carrierName: 'Flipkart',
        disable: true
      },
      {
        imageUrl: "assets/images/SNAPDEAL.PNG",
        carrierName: 'Snapdeal',
        disable: true
      },
      {
        imageUrl: "assets/images/BIGCOMMERCE.PNG",
        carrierName: 'Bigcommerce',
        disable: true
      },
      {
        imageUrl: "assets/images/WOOCOMMERCE.png",
        carrierName: 'Woocommerce',
        disable: true
      },
      {
        imageUrl: "assets/images/OPENCART.png",
        carrierName: 'Opencart',
        disable: true
      },
      {
        imageUrl: "assets/images/PRESTASHOP.png",
        carrierName: 'Prestashop',
        disable: true
      },
      {
        imageUrl: "assets/images/STOREHIPPO.png",
        carrierName: 'Storehippo',
        disable: true
      },
      {
        imageUrl: "assets/images/googleSheet.png",
        carrierName: 'Googlesheet',
        disable: true
      },
      {
        imageUrl: "assets/images/UNICOMMERCE.png",
        carrierName: 'Unicommerce',
        disable: false
      },
      {
        imageUrl: "assets/images/ZOHO.png",
        carrierName: 'Zoho',
        disable: true
      },
      {
        imageUrl: "assets/images/SHIPROCKET.png",
        carrierName: 'Shiprocket',
        disable: false
      },
      {
        imageUrl: "assets/images/firstcry.png",
        carrierName: 'Firstcry',
        disable: false
      },
      {
        imageUrl: "assets/images/jollychic.png",
        carrierName: 'Jollychic',
        disable: false
      },
      {
        imageUrl: "assets/images/messho.png",
        carrierName: 'Messho',
        disable: false
      },
      {
        imageUrl: "assets/images/ajio.png",
        carrierName: 'Ajio',
        disable: false
      },
      {
        imageUrl: "assets/images/myntra.png",
        carrierName: 'Myntra',
        disable: false
      },
      {
        imageUrl: "assets/images/limeroad.png",
        carrierName: 'Limeroad',
        disable: false
      },
      {
        imageUrl: "assets/images/jignov.png",
        carrierName: 'Jignov',
        disable: false
      },
      {
        imageUrl: "assets/images/snapmint.png",
        carrierName: 'Snapmint',
        disable: false
      },
      {
        imageUrl: "assets/images/rediff.png",
        carrierName: 'rediff',
        disable: false

      },
      {
        imageUrl: "assets/images/dalmia.png",
        carrierName: 'Dalmia',
        disable: false

      },
      {
        imageUrl: "assets/images/maccaron.png",
        carrierName: 'Maccaron',
        disable: false

      },
      {
        imageUrl: "assets/images/mirraw.png",
        carrierName: 'Mirraw',
        disable: false

      },
      {
        imageUrl: "assets/images/simsim.png",
        carrierName: 'Simsim',
        disable: false

      },
      {
        imageUrl: "assets/images/amazonflex.png",
        carrierName: 'Amazonflex',
        disable: false

      },
      {
        imageUrl: "assets/images/glowroad.png",
        carrierName: 'Glowroad',
        disable: false

      },
      {
        imageUrl: "assets/images/fynd.png",
        carrierName: 'Fynd',
        disable: false

      },
      {
        imageUrl: "assets/images/blibli.png",
        carrierName: 'Blibli',
        disable: false

      },
      {
        imageUrl: "assets/images/tataq.png",
        carrierName: 'Tataq',
        disable: false

      },
      {
        imageUrl: "assets/images/trell.png",
        carrierName: 'Trell',
        disable: false

      },
      {
        imageUrl: "assets/images/travosh.png",
        carrierName: 'Travosh',
        disable: false

      },
      {
        imageUrl: "assets/images/jabong.png",
        carrierName: 'Jabong',
        disable: false

      },
      {
        imageUrl: "assets/images/voonik.png",
        carrierName: 'Voonik',
        disable: false

      },
      {
        imageUrl: "assets/images/spoyl.png",
        carrierName: 'Spoyl',
        disable: false

      },
      {
        imageUrl: "assets/images/lazada.png",
        carrierName: 'Lazada',
        disable: false
      }
      ];
  }

  routing(routerUrl) {
    if (routerUrl === "Magento") {
      this.router.navigate(['/admin/magentoUser/' + 1]);
    }
    if (routerUrl === "Shopify") {
      this.router.navigate(['/admin/shopifyUser/' + 4]);
    }
    if (routerUrl === "Amazon") {
      this.router.navigate(['/admin/amazonUser/' + 3]);
    }
    if (routerUrl === "Shopclues") {
      this.router.navigate(['/admin/shopcluesUser/' + 5]);
    }
    if (routerUrl === "Flipkart") {
      this.router.navigate(['/admin/flipkartUser/' + 2]);
    }
    if (routerUrl === "Snapdeal") {
      this.router.navigate(['/admin/snapDealUser/' + 9]);
    }
    if (routerUrl === "Bigcommerce") {
      this.router.navigate(['/admin/bigCommerceUser/' + 2]);
    }
    if (routerUrl === "Woocommerce") {
      this.router.navigate(['/admin/woocommerceUser/' + 8]);
    }
    if (routerUrl === "Opencart") {
      this.router.navigate(['/admin/opencartUser/' + 9]);
    }
    if (routerUrl === "Prestashop") {
      this.router.navigate(['/admin/prestaShopUser/' + 10]);
    }
    if (routerUrl === "Storehippo") {
      this.router.navigate(['/admin/storeHippo/' + 11]);
    }
    if (routerUrl === "Googlesheet") {
      this.router.navigate(['/admin/googleSheet/' + 12]);
    }
    if (routerUrl === "Zoho") {
      this.router.navigate(['/admin/zohoCommerceUser/' + 10]);
    }
  }

  ngOnInit() { }

}

